var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    class: _vm.labelClasses,
    attrs: {
      "for": _vm.id
    }
  }, [_c('span', {
    staticClass: "Polaris-Choice__Control"
  }, [(!_vm.$slots.children) ? _vm._t("default", [_vm._v("\n                " + _vm._s(_vm.children) + "\n            ")]) : _vm._e(), _vm._v(" "), _vm._t("children")], 2), _vm._v(" "), _c('span', {
    staticClass: "Polaris-Choice__Label"
  }, [_vm._v("\n            " + _vm._s(_vm.label) + "\n        ")])]), _vm._v(" "), (typeof _vm.error === 'string' || _vm.helpText || _vm.$slots.helpText) ? _c('div', {
    staticClass: "Polaris-Choice__Descriptions"
  }, [(typeof _vm.error === 'string') ? _c('div', {
    staticClass: "Polaris-Choice__Error",
    attrs: {
      "id": _vm.id + 'Error'
    }
  }, [_c('div', {
    staticClass: "Polaris-Choice__ErrorIcon"
  }, [_c('polaris-icon', {
    attrs: {
      "source": _vm.alertIcon
    }
  }), _vm._v("\n                " + _vm._s(_vm.error) + "\n            ")], 1)]) : _vm._e(), _vm._v(" "), (_vm.helpText || _vm.$slots.helpText) ? _c('div', {
    staticClass: "Polaris-Choice__HelpText",
    attrs: {
      "id": _vm.id + 'HelpText'
    }
  }, [_vm._t("helpText", [_vm._v(_vm._s(_vm.helpText))])], 2) : _vm._e()]) : _vm._e()])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-07695ac0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07695ac0","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisChoice.vue
// module id = 249
// module chunks = 0